import {
  DisbursementStatus,
  DisbursementType
} from '@percent/admin-dashboard/api/actions/disbursements/disbursements.types'
import { LocaleKey } from '@percent/admin-dashboard/i18n/config'

/**
 * Shared by the filter row and the chips that summarise it. Both need the same labels for the same
 * values, so they are declared once here as locale keys and translated by whichever renders them.
 */

export const PAID_BY_FILTER_TYPE = {
  CHEQUE: 'CHEQUE',
  CARD: 'CARD',
  BANK_TRANSFER: 'BANK_TRANSFER'
} as const

export type PaidByFilterType = typeof PAID_BY_FILTER_TYPE[keyof typeof PAID_BY_FILTER_TYPE]

export const STATUS_FILTER_TYPE = {
  ACTION_REQUIRED: 'ACTION_REQUIRED',
  NO_ACTION_REQUIRED: 'NO_ACTION_REQUIRED'
} as const

export type StatusFilterType = typeof STATUS_FILTER_TYPE[keyof typeof STATUS_FILTER_TYPE]

export const PAID_BY_LABEL_KEY: Record<PaidByFilterType, LocaleKey> = {
  [PAID_BY_FILTER_TYPE.BANK_TRANSFER]: 'dropdown.type.bankTransfer.title',
  [PAID_BY_FILTER_TYPE.CARD]: 'dropdown.type.card.title',
  [PAID_BY_FILTER_TYPE.CHEQUE]: 'dropdown.type.cheque.title'
}

export const STATUS_LABEL_KEY: Record<StatusFilterType, LocaleKey> = {
  [STATUS_FILTER_TYPE.ACTION_REQUIRED]: 'dropdown.status.actionRequired.title',
  [STATUS_FILTER_TYPE.NO_ACTION_REQUIRED]: 'dropdown.status.noActionRequired.title'
}

/** Display order, shared so a chip lists selections in the order the dropdown offers them. */
export const PAID_BY_ORDER: PaidByFilterType[] = [
  PAID_BY_FILTER_TYPE.BANK_TRANSFER,
  PAID_BY_FILTER_TYPE.CARD,
  PAID_BY_FILTER_TYPE.CHEQUE
]

export const STATUS_ORDER: StatusFilterType[] = [
  STATUS_FILTER_TYPE.ACTION_REQUIRED,
  STATUS_FILTER_TYPE.NO_ACTION_REQUIRED
]

export const PAID_BY_TO_DISBURSEMENT_TYPE: Record<PaidByFilterType, DisbursementType> = {
  [PAID_BY_FILTER_TYPE.CHEQUE]: DisbursementType.CHEQUE,
  [PAID_BY_FILTER_TYPE.CARD]: DisbursementType.EXTERNAL,
  [PAID_BY_FILTER_TYPE.BANK_TRANSFER]: DisbursementType.INTERNAL
}

export const ACTION_REQUIRED_STATUSES = [
  DisbursementStatus.PENDING_APPROVAL,
  DisbursementStatus.PENDING_TRUSTEE_APPROVAL,
  DisbursementStatus.PENDING_AGENT_APPROVAL,
  DisbursementStatus.PENDING_MANAGER_APPROVAL,
  DisbursementStatus.PENDING_PAYMENT,
  DisbursementStatus.SENT
]

export const NO_ACTION_REQUIRED_STATUSES = [DisbursementStatus.PAID, DisbursementStatus.CANCELLED]

export const ALL_FOUNDATIONS_VALUE = ''
